import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>© {new Date().getFullYear()} Hasbara.ai - Defending Truth Online</p>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#004aad',
    color: 'white',
    textAlign: 'center',
    padding: '28px 20px',
  },
  text: {
    margin: 0,
    fontSize: '14px',
    opacity: 0.9,
    letterSpacing: '0.02em',
  },
};

export default Footer;
